import dayjs from 'utils/dayjs';

const getCSVData = (grpDisp) => {
    const secDetails = 'Details';
    const secDates = 'Dates';
    const secNotes = 'Notes';
    const secHotel = 'Your Hotel';
    const secGroup = 'Group';
    const secAddSpend = 'Additional Spend';
    const secCalculation = 'Calculation';
    const secWithoutGroup = 'Without Group';
    const secWithGroup = 'With Group';

    const hotel = grpDisp.roomTypes[0];

    const rows = [
        ['Section', 'Label', 'Value', 'Profit margin (%)', 'Total'],
        [secDetails, 'Group name', grpDisp.groupName, '', ''],
        [secDates, 'Check-in', dayjs(grpDisp.startDate).format('DD/MM/YYYY'), '', ''],
        [secDates, 'Check-out', dayjs(grpDisp.endDate).format('DD/MM/YYYY'), '', ''],
        [secNotes, 'Notes', grpDisp.notes, '', ''],
        [secDetails, 'Budget', '', '', grpDisp.groupBudget],
        [secDetails, 'Apply group wash', '', '', grpDisp.groupWash],
        [secDetails, 'Wash %', '', '', grpDisp.groupWashPercent],
        [secDetails, 'Apply commission', '', '', grpDisp.groupCommission],
        [secDetails, 'Commission %', '', '', grpDisp.groupCommissionPercent],
        [secDetails, 'Budget', '', '', grpDisp.groupBudget],
        [secHotel, 'Total rooms', '', '', hotel.hotelSize],
        [secHotel, 'Estimated ADR(without group)', '', '', hotel.estADR],
        [secHotel, 'Cost Of Occupied Room', '', '', hotel.occupiedRoomCost],
        [secHotel, 'Net ADR', '', '', hotel.netADR],
        [
            secHotel,
            'Normal Additional Spend per night',
            grpDisp.averageNormalSpend.gross,
            grpDisp.averageNormalSpend.percent,
            grpDisp.averageNormalSpend.net,
        ],
    ];
    grpDisp.forecasts.forEach((forecast) =>
        rows.push(
            [secGroup, 'Date', forecast.date, '', ''],
            [secGroup, 'Forecast rooms (without group)', '', '', forecast.forecast],
            [secGroup, 'No. of group rooms', '', '', forecast.groupSize],
            [secGroup, 'No. of Comp rooms', '', '', forecast.compRooms],
            [secGroup, 'Displaced rooms', '', '', forecast.displacedRooms],
        ),
    );
    grpDisp.additionalSpend.forEach((spend) => {
        let total = spend.amount;
        if (grpDisp.groupWash && spend.applyWash) {
            total += ` (${grpDisp.groupWashPercent}% wash applied)`;
        }
        if (grpDisp.groupCommission && spend.applyCommission) {
            total += ` (${grpDisp.groupCommissionPercent}% commission applied)`;
        }
        rows.push([secAddSpend, spend.name, spend.value, spend.percentage, total]);
    });
    rows.push([
        secCalculation,
        'Group Additional Spend per night',
        '',
        '',
        grpDisp.totalAdditionalSpendPerRoomPerNight,
    ]);
    rows.push([secCalculation, 'Break even', '', '', hotel.minRate]);
    rows.push([secCalculation, 'Profit/Loss', '', '', grpDisp.outcome]);
    const withoutGroup = grpDisp.summary.find((summary) => summary.id === 'withGroup');
    if (withoutGroup) {
        rows.push([secWithoutGroup, 'Rooms', '', '', withoutGroup.rooms]);
        rows.push([secWithoutGroup, 'Revenue (NETT)', '', '', withoutGroup.revenue]);
        rows.push([secWithoutGroup, 'ADR (NETT)', '', '', withoutGroup.adr]);
        rows.push([secWithoutGroup, 'RevPAR (NETT)', '', '', withoutGroup.revPar]);
        rows.push([secWithoutGroup, 'Additional Spend (NETT)', '', '', withoutGroup.additionalSpend]);
        rows.push([secWithoutGroup, 'TRevPAR (NETT)', '', '', withoutGroup.trevPar]);
        rows.push([secWithoutGroup, 'Gross', '', '', withoutGroup.gross]);
    }
    const withGroup = grpDisp.summary.find((summary) => summary.id === 'withoutGroup');
    if (withGroup) {
        rows.push([secWithGroup, 'Rooms', '', '', withGroup.rooms]);
        rows.push([secWithGroup, 'Revenue (NETT)', '', '', withGroup.revenue]);
        rows.push([secWithGroup, 'ADR (NETT)', '', '', withGroup.adr]);
        rows.push([secWithGroup, 'RevPAR (NETT)', '', '', withGroup.revPar]);
        rows.push([secWithGroup, 'Additional Spend (NETT)', '', '', withGroup.additionalSpend]);
        rows.push([secWithGroup, 'TRevPAR (NETT)', '', '', withGroup.trevPar]);
        rows.push([secWithGroup, 'Gross', '', '', withGroup.gross]);
    }
    return rows;
};

export { getCSVData };
